(function(){
  if(window.wmCartSub) return;
  window.wmCartSub = true;
  function update(line, qty, plan, el){
    var drawer = document.querySelector('cart-drawer');
    var item = el.closest('cart-drawer-item');
    if(item) item.classList.add('cart-drawer__item--loading');
    var body = { line: parseInt(line, 10), quantity: parseInt(qty, 10), selling_plan: plan || null };
    if(drawer) body.sections = drawer.dataset.sectionId;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function(r){ return r.json(); }).then(function(d){
      if(drawer && d.sections && typeof drawer.renderCartContents === 'function'){ drawer.renderCartContents({ sections: d.sections, itemCount: d.item_count }); }
      else { window.location.reload(); }
    }).catch(function(){ if(item) item.classList.remove('cart-drawer__item--loading'); });
  }
  document.addEventListener('change', function(e){
    var t = e.target;
    if(t.matches && t.matches('[data-wm-sub]')){
      var box = t.closest('.wm-it-sub');
      if(t.dataset.none){ box.classList.toggle('on', t.checked); var s = box.querySelector('.wm-it-soon'); if(s) s.hidden = !t.checked; return; }
      var sel = box.querySelector('[data-wm-freq]');
      update(t.dataset.line, t.dataset.qty, t.checked && sel ? sel.value : null, t);
    }
    if(t.matches && t.matches('[data-wm-freq]') && !t.dataset.static){
      var chk = t.closest('.wm-it-sub').querySelector('[data-wm-sub]');
      if(chk && chk.checked) update(t.dataset.line, t.dataset.qty, t.value, t);
    }
  });
})();